import {
    MapOptions
} from "esdm-map";
import { LayerGroupCollection } from "esdm-map/dist/layers/groups/LayerGroupCollection";
import { BucksBaseLayers } from "./CustomClient_BaseLayerFactory_27700";


export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {       

        let opt = new MapOptions();       
        opt.bingApiKey = $(`#${mapElementId}`).data("bing-api-key");
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [BucksBaseLayers.BucksOS,BucksBaseLayers.BucksAerial, BucksBaseLayers.BucksOS1stEdition];
        opt.defaultBaseMap = BucksBaseLayers.BucksOS;
        opt.enableBoundsTracking = true;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 13;
        opt.minZoom = 9;
        opt.maxZoom = 19;
        opt.extent = [455674.40, 172322.31, 514896.93, 261953.12];
        opt.mapCentre = [469191.36, 233854.64];
        opt.displayProjection = "EPSG:27700";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;        
        opt.zoomToNearestBounds = false;
        return opt;
    }

}